export enum CashRegisterDropdownKey {
  APPLICATIONS_SECTION = 'applications_section',
  APPLICATIONS = 'applications',
  MANAGERS_SECTION = 'managers_section',
  MANAGERS = 'managers',
  OPERATOR_VOUCHERS_SECTION = 'operator_vouchers_section',
  OPERATORS_SECTION = 'operators_section',
  OPERATORS = 'operators',
}
